import { CitizenshipAvia } from 'shared/api/CitizenshipModel.ts'
import { Response } from 'shared/models/general.ts'

export enum GENDER {
  MALE = 'male',
  FEMALE = 'female',
}

export enum DOCUMENT {
  ID = 'idcard',
  PASSPORT = 'intpassport',
  BIRTH_CERTIFICATE = 'birthcert',
}

export type UserAuthorityType = 'MISLAMIC_CLIENT' | 'BANK_CLIENT'

export const NotAllowMplusForRolesUser = [
  'MISLAMIC_CLIENT',
] as UserAuthorityType[]

export interface IDocument {
  first_name: string
  last_name: string
  gender: string
  document_type: DOCUMENT | string
  document_number: string
  document_expire: string
  date_of_birth: string
  middle_name: string
  citizenship: string
  date_of_issue: string | null
  country_of_issue: string | null
  citizenship_obj?: CitizenshipAvia
}

export interface Account {
  user_authority_type?: UserAuthorityType
  last_name: string
  middle_name: string
  first_name: string
  phone_number?: string
  gender?: GENDER
  date_of_birth?: string
  document_inn: string
  email?: string
  citizenship?: string | null
  id_card_number: string | null
  id_card_expire: string | null
  international_passport: IDocument
  id_card: IDocument
  mbank_user_role: UserAuthorityType
  is_mplus_available?: boolean
  has_buyed_products?: boolean
  mplus_commission?: string
  buyed_products_kfu?: boolean
  has_certificate?: boolean
  citizenship_obj: CitizenshipAvia
  has_favorites: boolean
  mbank_orginal_info: {
    first_name: string
    last_name: string
  }
}

export interface Token {
  access_token?: string
  access_expires?: string
  token_type?: string
  user_data: Account
}

export interface LoginUser extends Response<Token> {}

export interface ResponseUser extends Response<Account> {}

export interface AppSettings {
  has_favorites: boolean
  is_mplus_available: boolean
  mplus_commission: string
  bus_service_available?: boolean
  client_state?: Record<string, ClientStateValue>
  is_promocode_available?: boolean
  is_minstallment_available: boolean
}

export type ClientStateValue =
  | string
  | boolean
  | number
  | null
  | Record<string, unknown>
  | unknown[]

export interface SentSettingOfUser {
  key: string
  value: ClientStateValue
}

export const DocumentTypes = {
  idcard: {
    name: 'id_passport',
    key: 'idcard',
  },
  intpassport: {
    name: 'passport',
    key: 'intpassport',
  },
  birthcert: {
    name: 'birth_certificate',
    key: 'birthcert',
  },
}

export const DocumentTypesList = Object.keys(DocumentTypes)?.map((key) => ({
  name: DocumentTypes[key as keyof typeof DocumentTypes].name,
  key: key,
}))
